<div class="mx-auto py-8 w-full">
  <div class="header">
    <div>
      <h1 class="title">Vue Coordonnateur</h1>
    </div>
  </div>

  <p-tabs styleClass="fullwidth-tabs" [(value)]="activeTabValue">
    <p-tablist>
      <p-tab value="equipment-structure">
        <span class="inline-flex items-center gap-2">
          <span>Structure d'équipement</span>
        </span>
      </p-tab>
      <p-tab value="gain-parameters" *ind4HasRole="'SED_PLUS_ADMIN'">
        <span class="inline-flex items-center gap-2">
          <span>Paramètres du module de gain</span>
        </span>
      </p-tab>
      <p-tab value="gain-formula-templates" *ind4HasRole="'SED_PLUS_ADMIN'">
        <span class="inline-flex items-center gap-2">
          <span>Modèles de formule de gain</span>
        </span>
      </p-tab>
      <p-tab value="migration" *ind4HasRole="'SED_PLUS_ADMIN'">
        <span class="inline-flex items-center gap-2">
          <span>Migration de données</span>
        </span>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="equipment-structure">
        <app-equipment-structure-import></app-equipment-structure-import>
      </p-tabpanel>
      <p-tabpanel value="gain-parameters" *ind4HasRole="'SED_PLUS_ADMIN'">
        <app-gain-parameters></app-gain-parameters>
      </p-tabpanel>
      <p-tabpanel
        value="gain-formula-templates"
        *ind4HasRole="'SED_PLUS_ADMIN'"
      >
        <app-gain-formula-templates></app-gain-formula-templates>
      </p-tabpanel>
      <p-tabpanel value="migration">
        <app-migration-import></app-migration-import>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
